import {TableDefinition} from '../../models';

export const CONTACT_RELATION_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.ContactRelation.uuid',
    prop: 'uuid',
    visible: false,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.firstName',
    prop: 'firstName',
    visible: true,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.lastName',
    prop: 'lastName',
    visible: true,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.email',
    prop: 'email',
    visible: true,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.phoneNumber',
    prop: 'phoneNumber',
    visible: true,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.businessTitle',
    prop: 'businessTitle',
    visible: false,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.gender',
    prop: 'gender',
    visible: false,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.workplaces',
    prop: 'workplaces',
    visible: true,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.groups',
    prop: 'groups',
    visible: false,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.ContactRelation.specialisations',
    prop: 'specialisations',
    visible: false,
    objectName: 'ContactRelation',
    searchFieldType: 'STRING',
  },
];
